import React, { useState, useEffect, useMemo } from 'react';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {convertDotNetTimeToMomentDate} from '../helpers/dateTime';
import Day from "../components/Day";

import './ChooseDeliveryTime.scss';

const ChooseDeliveryTime = ({
  closeModal,
  branchInfo,
  currentUiLanguageId,
  onOk,
  onClose,
  t,
}) => {

  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [timeSlots, setTimeSlots] = useState([]);  

  const onSubmitDate = () => {
    selectedDay.date.setMinutes(selectedDay.date.getMinutes() + selectedTime.minutes);
    onOk(selectedDay.date);
    closeModal();
  };

  const onCancel = () => {
    onClose();
    closeModal();
  }

  const onSelectedTime = (time) => {
    setSelectedTime(time);
  }

  const onSelectedDay = (day) => {
    setSelectedDay(day);

    const times = getTimesForDay(day);
    setTimeSlots(times);
  }

  const getTimesForDay = (day) => {
    const times = [];

    if (day.workDay.start_dt && day.workDay.end_dt) {
      const starTime = convertDotNetTimeToMomentDate(day.workDay.start_dt);
      const endTime = convertDotNetTimeToMomentDate(day.workDay.end_dt);

      let current = toMinutes(starTime);
      const endMinutes = toMinutes(endTime);
      let index = 0;
      while (current <= endMinutes - 30) {
        times.push(toTime(current, index));
        current += 30;
        index +=1;
      }
    }
    return times;
  };

  const toMinutes = (t) => {
    return t.hour() * 60 + t.minute();
  };
  
  const toTime = (mins, index) => {
    const startH = Math.floor(mins / 60);
    const startM = mins % 60;


    const endH = Math.floor((mins + 30) / 60);
    const endM = (mins + 30) % 60;

    return {
      index,
      label : `${String(startH).padStart(2, '0')}:${String(startM).padStart(2, '0')} - ${String(endH).padStart(2, '0')}:${String(endM).padStart(2, '0')}`,
      minutes : mins
    };
  };

  const GetLanguage = () => {
    if (currentUiLanguageId === 2) {
      return "he-HE";
    } else if (currentUiLanguageId === 3) {
      return "ru-RU";
    }
    return "en-EN";
  };

    const languageCode = GetLanguage();

    const days = useMemo(() => {
      return Array.from({ length: 30 }, (_, i) => {
        const date = new Date();
        date.setDate(date.getDate() + i);
    
        const dayNumber = date.getDay();
    
        const workDay = branchInfo.DeliveryTimes.find(
          (dateObj) => dateObj.day_of_week === dayNumber
        );
    
        date.setHours(0, 0, 0, 0);        
        return {
          date,
          index : i,
          weekday: date.toLocaleDateString(languageCode, {
            weekday: "long",
          }),
          label: date.toLocaleDateString(languageCode, {
            day: "2-digit",
            month: "2-digit",
          }).replace('.', '/'),
          workDay,
        };
      });
    }, [branchInfo, languageCode]);

    useEffect(() => {
      if (days.length > 0 && !selectedDay) {

        const firstAvailable = days.find(d => d.workDay.start_dt && d.workDay.end_dt);

        setSelectedDay(firstAvailable);
        onSelectedDay(firstAvailable);

        setSelectedDay(firstAvailable);
        onSelectedDay(firstAvailable);
      }
    }, [days]);

  return (
    <div className="choose-container">

      <div
        className={"choose-close-modal"}
        onClick={() => {
        onCancel();
        }}
      >
        <FontAwesomeIcon icon="chevron-down" />
      </div>

      <div className="main-title">{t("selected_datetime_modal.title")}</div>
      <div className="sub-title">{t("selected_datetime_modal.sub_title")}</div>

      <div className="columns">
        <div className="column">
          <div className="column-title">{t("selected_datetime_modal.day_title")}</div>

          <div className="list">
            {days.map((day, index) => (
              <Day key={index} day={day} isActive={selectedDay?.index === day.index} onSelectedDay={onSelectedDay}/>
            ))}
          </div>
        </div>

        <div className="column">
          <div className="column-title">{t("selected_datetime_modal.time_title")}</div>

          <div className="list">
            {timeSlots.map((t, i) => (
              <div key={i} className={selectedTime?.index === t.index ? "item-time active" : "item-time"} onClick={() => { onSelectedTime(t) }}> {t.label} </div>
            ))}
          </div>
        </div>
      </div>
      <div className="action-buttons">
        <button
          type="submit"
          className="btn btn-primary am-button am-button-primary am-button-inline"
          disabled={!selectedTime}
          onClick={onSubmitDate}
        >
            {t("buttons.choose_day")}
          </button>
      </div>
    </div>  
  );
};

export default withTranslation()(ChooseDeliveryTime);
